import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Listing } from "@b2bportal/homes-api";
import type { Lodging } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelShopMap } from "@tenant/hotels";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  DialogTrigger,
  Icon,
} from "@tenant/ui";
import { Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import clsx from "clsx";
import styles from "./styles.module.scss";

export interface HotelShopMapComponentProps extends PlatformComponentProps {
  hotel: Lodging | Listing;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelShopMap;

export const HotelShopMap = (props: HotelShopMapComponentProps) => {
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const { children, className } = props;

  const { context, text } = useHotelShopMap(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("map-container")}>
        <Map
          mapId={"hotel-shop-map-static"}
          style={{ height: "100%", width: "100%" }}
          center={{
            lat: context.mapCoordinates.lat,
            lng: context.mapCoordinates.lng - 0.025,
          }}
          defaultZoom={13}
          gestureHandling={"none"}
          fullscreenControl={false}
          disableDefaultUI
        >
          <AdvancedMarker position={context.mapCoordinates}>
            <Icon
              className={cn("map-marker")}
              iconName={IconNameEnum.ui__mapMarker}
            />
          </AdvancedMarker>
        </Map>
        <Dialog>
          <DialogTrigger asChild>
            <Button
              className={cn("direction-map-trigger")}
              buttonType={ButtonTypeEnum.Secondary}
            >
              {t("core-hotels.shop.map.openButton")}
            </Button>
          </DialogTrigger>
          <DialogContent
            title={
              <>
                {text.hotelName}
                <span className={cn("map-address")}>{text.address}</span>
              </>
            }
            className={cn("dialog-content")}
            fullScreen
          >
            <Map
              mapId={"hotel-shop-map"}
              style={{ height: "100%", width: "100%" }}
              defaultCenter={context.mapCoordinates}
              defaultZoom={13}
              gestureHandling={"greedy"}
              className={cn("distance-map")}
              clickableIcons={false}
              mapTypeControl={false}
              streetViewControl={false}
              rotateControl={false}
              scaleControl={true}
              zoomControl={true}
              fullscreenControl={true}
              cameraControl={false}
            >
              <AdvancedMarker position={context.mapCoordinates}>
                <Icon
                  className={cn("map-marker", ["origin"])}
                  iconName={IconNameEnum.ui__mapMarker}
                />
              </AdvancedMarker>
            </Map>
          </DialogContent>
        </Dialog>
      </div>
      {children}
    </div>
  );
};
